import uniqueId from 'lodash.uniqueid';
import moment from 'moment-timezone';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {findOrganisation} from '../organisation/FakeOrganisationService';
import {findProject} from '../project/FakeProjectService';
import {interventionRole, PROJECT_STATUS, status, ACTRADIS_MASTER_PLATFORM} from '../../utils/constant';

let interventionsInDb = [
  {
    invitationId: 350,
    role: interventionRole.CLIENT,
    status: status.PENDING,
    creationDate: '2019-01-15T10:15:30.00Z',
    lastSentDate: '2019-01-15T10:15:30.00Z',
    resendable: true,
    interventionPath: '',
    email: 'client-AFB@alg.fr',
    organisation: {
      enabled: true,
      depositor: false,
      fullName: 'AFB',
      organisationId: 12,
      registrationNumber: 12564848553,
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: false,
    dossierDocumentsAccessible: false
  },
  {
    interventionId: 10,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '1/10',
    organisation: {
      enabled: true,
      depositor: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    email: null,
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 1,
    role: interventionRole.GENERAL_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '1',
    interventionDate: '2019-01-15T17:00:15Z',
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    email: undefined,
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 7,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '1/10/3',
    creationDate: '2018-10-30T10:15:30.00Z',
    lastSentDate: '2018-11-02T09:10:00.00Z',
    resendable: false,
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 3,
      country: COUNTRY.GERMANY,
      fullName: 'ILG',
      registrationNumber: '50320789',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    email: null,
    dossierStateAccessible: true,
    dossierDocumentsAccessible: false
  },
  {
    interventionId: 4,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '1/10/4',
    creationDate: null,
    lastSentDate: '2018-10-30T10:15:30.00Z',
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 4,
      country: COUNTRY.GERMANY,
      fullName: 'Only LYON',
      registrationNumber: '50320789',
      address: {
        addressLine: '21, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      masterPlatform: ACTRADIS_MASTER_PLATFORM
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    email: null,
    dossierStateAccessible: false,
    dossierDocumentsAccessible: false
  },
  {
    interventionId: 15,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.PENDING,
    interventionPath: '1/15',
    creationDate: null,
    lastSentDate: '2018-10-30T10:15:30.00Z',
    resendable: true,
    organisation: {
      enabled: true,
      depositor: true,
      organisationId: 11,
      country: COUNTRY.GERMANY,
      fullName: 'GIFA',
      registrationNumber: '50320789',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: false,
    dossierDocumentsAccessible: false
  },
  {
    invitationId: 352,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.PENDING,
    interventionPath: '1/16',
    email: 'invited-sub-FIGAL@alg.fr',
    creationDate: null,
    lastSentDate: '2018-10-30T10:15:30.00Z',
    resendable: true,
    organisation: {
      enabled: true,
      depositor: true,
      organisationId: 11,
      country: COUNTRY.GERMANY,
      fullName: 'FIGAL'
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      email: undefined,
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: false,
    dossierDocumentsAccessible: false
  },
  {
    interventionId: 7854,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.REJECTED,
    rejectionReason: 'NO_LONGER_WORKING_WITH_ORGANISATION',
    interventionPath: '1/10/3',
    creationDate: null,
    lastSentDate: '2018-10-30T10:15:30.00Z',
    resendable: false,
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 82,
      country: COUNTRY.GERMANY,
      fullName: 'Test Orga',
      registrationNumber: '50320782',
      address: {
        addressLine: '23, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 1,
      name: 'Incity',
      address: {
        addressLine: '55, rue de la Republique',
        city: 'Lyon',
        region: 'Rhone Alpes Auvergne',
        postCode: '69003'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2017-01-15',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    email: null,
    dossierStateAccessible: false,
    dossierDocumentsAccessible: false
  },
  {
    interventionId: 3,
    role: interventionRole.GENERAL_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '10',
    creationDate: null,
    lastSentDate: '2019-01-24T10:15:30.00Z',
    resendable: false,
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 42,
      name: 'Britannia',
      address: {
        addressLine: 'Bd Eugène Deruelle',
        city: 'LYON',
        region: 'Auvergne Rhone-Alpes',
        postCode: '69000'
      },
      country: COUNTRY.GERMANY,
      openingDate: '2001-09-28',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'ALG',
        registrationNumber: '52773773',
        address: {
          addressLine: '20, boulevard eugène deruelle',
          postCode: '69003',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 5,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '10/1',
    creationDate: null,
    lastSentDate: '2018-10-30T10:15:30.00Z',
    resendable: false,
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      },
      interoperatedOrganisation: {
        country: COUNTRY.FRANCE,
        enabled: true,
        masterPlatform: ACTRADIS_MASTER_PLATFORM
      }
    },
    project: {
      projectId: 42,
      name: 'Britannia',
      address: {
        addressLine: 'Bd Eugène Deruelle',
        city: 'LYON',
        region: 'Auvergne Rhone-Alpes',
        postCode: '69000'
      },
      country: COUNTRY.GERMANY,
      openingDate: '2001-09-28',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'ALG',
        registrationNumber: '52773773',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 27,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '10/1',
    organisation: {
      enabled: false,
      depositor: false,
      organisationId: 2,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 42,
      name: 'Britannia 2',
      address: {
        addressLine: 'Bd Eugène Deruelle',
        city: 'LYON',
        region: 'Auvergne Rhone-Alpes',
        postCode: '69000'
      },
      country: COUNTRY.GERMANY,
      openingDate: '2001-09-28',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'ALG',
        registrationNumber: '52773773',
        address: {
          addressLine: '20, boulevard eugène deruelle',
          postCode: '69003',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 28,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ACCEPTED,
    interventionPath: '10/1',
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 42,
      name: 'Tour Eiffel',
      address: {
        addressLine: 'Avenue des Champs Elysées',
        city: 'PARIS',
        region: 'Ile-de-France',
        postCode: '75000'
      },
      country: COUNTRY.FRANCE,
      openingDate: '2001-09-28',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'Organisation 1',
        registrationNumber: '123456',
        address: {
          addressLine: '50, rue de l\'oie',
          postCode: '69300',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  },
  {
    interventionId: 228,
    role: interventionRole.SUB_CONTRACTOR,
    status: status.ENDED,
    interventionPath: '1/1',
    organisation: {
      enabled: true,
      depositor: false,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '123456',
      address: {
        addressLine: '50, rue de l\'oie',
        postCode: '69300',
        city: 'Lyon'
      }
    },
    project: {
      projectId: 43,
      name: 'Britannia with a very large project name',
      address: {
        addressLine: 'Bd Eugène Deruelle',
        city: 'LYON',
        region: 'Auvergne Rhone-Alpes',
        postCode: '69000'
      },
      country: COUNTRY.GERMANY,
      openingDate: '2001-09-28',
      ownerOrganisation: {
        enabled: true,
        organisationId: 1,
        country: COUNTRY.GERMANY,
        fullName: 'ALG',
        registrationNumber: '52773773',
        address: {
          addressLine: '20, boulevard eugène deruelle',
          postCode: '69003',
          city: 'Lyon'
        }
      },
      projectStatus: PROJECT_STATUS.ACTIVE,
      closingDate: null
    },
    invitationEmitterOrganisation: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      }
    },
    dossierStateAccessible: true,
    dossierDocumentsAccessible: true
  }
];

export const findIntervention = (organisationId, projectId) => interventionsInDb.find(intervention => intervention.project.projectId === projectId && intervention.organisation.organisationId === organisationId);

export default class FakeInterventionService {
  searchByStatus(organisationId, selectedStatus, page = 0, size = 10) {
    const matchingInterventions = interventionsInDb.filter(intervention => intervention.organisation.organisationId === organisationId && intervention.status === selectedStatus);
    return Promise.resolve({
      interventions: matchingInterventions.slice(page * size, (page + 1) * size),
      totalCount: matchingInterventions.length,
      totalProjectsOwnedCount: matchingInterventions.length
    });
  }

  searchByClientAndSubcontractor(clientId, subcontractorId, selectedStatus, page = 0, size = 10) {
    const matchingInterventions = interventionsInDb.filter(intervention => intervention.organisation.organisationId === subcontractorId &&
      intervention.status === selectedStatus &&
      intervention.project.ownerOrganisation.organisationId === clientId);

    return new Promise(resolve => setTimeout(() => resolve({
      interventions: matchingInterventions.slice(page * size, (page + 1) * size),
      totalCount: matchingInterventions.length
    }), 0));
  }

  getInterventionByProjectId(organisationId, projectId) {
    const matchingIntervention = interventionsInDb.find(intervention => (intervention.organisation.organisationId === organisationId) && (intervention.project.projectId === projectId));

    return Promise.resolve(matchingIntervention);
  }

  getInterventionTree() {
    const matchingIntervention = interventionsInDb
      .filter(intervention => intervention.project.projectId === 1)
      .sort((a, b) => {
        if (a.interventionPath < b.interventionPath) {
          return -1;
        }

        if (a.interventionPath > b.interventionPath) {
          return 1;
        }

        return 0;
      });
    return Promise.resolve(matchingIntervention);
  }

  addInterventions(interventions) {
    const interventionsToCreate = interventions.map(intervention => {
      const parentIntervention = findIntervention(intervention.emitterOrganisationId, intervention.projectId);
      return {
        interventionId: Number(uniqueId()),
        role: intervention.role,
        interventionPath: parentIntervention ? `${parentIntervention.interventionPath}/${intervention.organisationId}` : intervention.organisationId,
        organisation: findOrganisation(intervention.organisationId),
        project: findProject(intervention.projectId),
        invitationEmitterOrganisation: findOrganisation(intervention.emitterOrganisationId)
      };
    });

    interventionsToCreate.forEach(intervention => interventionsInDb.push(intervention));

    return Promise.resolve(interventionsToCreate);
  }

  accept(interventionId) {
    const acceptedIntervention = interventionsInDb.find(intervention => intervention.interventionId === interventionId);
    acceptedIntervention.status = status.ACCEPTED;
    interventionsInDb[interventionsInDb.findIndex(intervention => intervention.interventionId === interventionId)] = acceptedIntervention;
    return Promise.resolve({status: 200});
  }

  reject() {
    return new Promise(resolve => setTimeout(() => resolve({status: 200}), 0));
  }

  resendInvitation(interventionId) {
    const sentInvitation = interventionsInDb.find(intervention => intervention.interventionId === interventionId);
    sentInvitation.resendable = false;
    sentInvitation.lastSentDate = moment().format('YYYY-MM-DDTHH:mm:ss');
    return Promise.resolve(sentInvitation);
  }

  searchByQuery(organisationId, query) {
    const matchingInterventions = interventionsInDb.filter(intervention => intervention.project.name.toLowerCase().startsWith(query.toLowerCase()) && (intervention.status === status.ACCEPTED || intervention.status === status.ENDED) && intervention.organisation.organisationId === organisationId);

    return Promise.resolve({
      interventions: matchingInterventions,
      totalCount: matchingInterventions.length
    });
  }

  getIntervention(interventionId) {
    const intervention = interventionsInDb.find(interventionItem => interventionItem.interventionId === Number(interventionId));
    return Promise.resolve(intervention);
  }

  endOrganisationParticipation(interventionId) {
    const endedIntervention = interventionsInDb.find(intervention => intervention.interventionId === interventionId);
    endedIntervention.status = status.ENDED;
    endedIntervention.endDate = moment().format('YYYY-MM-DDTHH:mm:ss');
    interventionsInDb[interventionsInDb.findIndex(intervention => intervention.interventionId === interventionId)] = endedIntervention;
    return Promise.resolve();
  }

  removeOrganisationParticipation(intervention) {
    interventionsInDb = interventionsInDb.filter(interventionDb => interventionDb.interventionId !== intervention.interventionId);
    return Promise.resolve();
  }

  updateProjectUserPermissions() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  updateProjectUserPermissionsAlreadyDone() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  isIdentificationNumberInProject() {
    return Promise.resolve(false);
  }

  setInterventionDate() {
    return Promise.resolve();
  }
}
